import { ImageSize } from '@ecg-marktplaats/media-util-js-lib';

export const MAIN_IMAGE_SIZE_LIST_DESKTOP = ImageSize.Large;
export const MAIN_IMAGE_SIZE_LIST_MOBILE = ImageSize.Medium;
export const MAIN_IMAGE_SIZE_GALLERY = ImageSize.ExtraLarge;
export const MAIN_IMAGE_SIZE_XXL = ImageSize.ExtraExtraLarge;

export const IMAGE_ALT_TEXT_LENGTH_LIMIT = 125;
